import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { GhostCta, useLanding } from './LandingKit';
import { fluid } from './landingTokens';

const STEPS = [
  { number: '01', title: 'Describe the job.', copy: 'Give Work your goal, source material, and any details that matter.' },
  { number: '02', title: 'Let Work take it from here.', copy: 'The agent uses its own computer and tools to carry out the project.' },
  { number: '03', title: 'Review and refine.', copy: 'Open your files beside the chat. Edit them yourself or ask for changes.' },
];

/** The workflow belongs beside the examples it explains. */
function LandingWorkMode() {
  const { c, width } = useLanding();
  const compact = width < 850;
  return (
    <View style={{ marginTop: fluid(width, 32, 48), paddingTop: 28, borderTopWidth: 1, borderTopColor: c.rule }}>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', columnGap: 24, marginBottom: 24 }}>
        <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 20, lineHeight: 28, letterSpacing: -0.4 }}>How Work works</Text>
        <GhostCta label="Explore Work" href="/docs/work" />
      </View>
      <View style={{ flexDirection: compact ? 'column' : 'row', gap: compact ? 24 : 40 }}>
        {STEPS.map(item => (
          <View key={item.number} style={{ flex: compact ? undefined : 1, minWidth: 0, flexDirection: 'row', gap: 16 }}>
            <Text style={{ color: c.muted, fontSize: 13, lineHeight: 25 }}>{item.number}</Text>
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text tag="h4" weight="semibold" style={{ color: c.ink, fontSize: 17, lineHeight: 25 }}>{item.title}</Text>
              <Text style={{ color: c.inkSoft, fontSize: 15, lineHeight: 24, marginTop: 8 }}>{item.copy}</Text>
            </View>
          </View>
        ))}
      </View>
      <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21, marginTop: 24 }}>Work mode is included with Gab AI Plus.</Text>
    </View>
  );
}

export default React.memo(LandingWorkMode);
